import React from 'react';
import { BookOpenIcon, FileTextIcon, ListChecksIcon, AccessibilityIcon, MicIcon, GiftIcon } from 'lucide-react';
const items = [{
  icon: BookOpenIcon,
  title: '6 Complete Volumes',
  text: 'One book per teaching skill, beginner to confident'
}, {
  icon: FileTextIcon,
  title: '60 Pages Per Book',
  text: 'Deep, complete, and genuinely useful'
}, {
  icon: ListChecksIcon,
  title: 'Ready-to-Teach Sequences',
  text: '30/45/60-minute classes, no prep needed'
}, {
  icon: AccessibilityIcon,
  title: 'Real-Body Adaptations',
  text: 'Modifications for real, everyday bodies'
}, {
  icon: MicIcon,
  title: 'Confidence & Voice Tools',
  text: 'Scripts, mindset, and cueing mastery'
}, {
  icon: GiftIcon,
  title: '5 Free Bonuses',
  text: 'Cheat sheets, scripts, and starter templates'
}];
export function WhatsInside() {
  return <section className="w-full bg-cream-deep px-5 py-16 sm:py-24" data-id="element-188" data-mp="3taq3oule6o1s">
      <div className="mx-auto max-w-5xl" data-id="element-189" data-mp="3ctnwxgm5ek0h">
        <h2 className="text-center text-2xl font-extrabold tracking-tight text-teal sm:text-4xl" data-id="element-190" data-mp="3cscov4lo6q3k">
          <span aria-hidden="true" data-id="element-191" data-mp="37ub7co3w6yu7">📚</span> What's Inside Yoga With Tina?
        </h2>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-192" data-mp="3ltawrxz8bhrf">
          {items.map(({
          icon: Icon,
          title,
          text
        }) => <article key={title} className="rounded-3xl border border-sage/25 bg-cream-card p-7 transition-shadow duration-200 hover:shadow-[0_16px_40px_-28px_rgba(31,79,74,0.5)]" data-id="element-193" data-mp="3hqwbz8c027xi">
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-terracotta-tint" data-id="element-194" data-mp="32vq9gvc44r8x">
                <Icon className="h-5 w-5 text-terracotta" aria-hidden="true" data-id="element-195" data-mp="2y59s50568lha" />
              </span>
              <h3 className="mt-5 text-lg font-bold text-teal" data-id="element-196" data-mp="2af754yg465pj">{title}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-ink-soft" data-id="element-197" data-mp="2ad2pjj8uri9f">{text}</p>
            </article>)}
        </div>
      </div>
    </section>;
}